import React from "react";
import {Form, Button, InputGroup} from "react-bootstrap";
import {format, parse} from "date-fns";
import { updateOrder } from "./utils/api";
import { toast } from 'react-toastify';


function validate(inputs) {
  return {
    cancel: isPresent(inputs.cancel) && inputs.cancel.toLowerCase() === 'cancel' ? null : 'You must type the word CANCEL'
  };
}

function isPresent(value) {
  return value && value.length > 0;  
}


class CancelForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cancel: '',
      errors: {
        cancel: ''
      },
      touched: {
        cancel: ''
      }
    };

    this.handleUpdateOrder = this.handleUpdateOrder.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  // **** HANDLE INPUT CHANGES **** //
  //use this to set touched for the input, to only show validation once field has been exited
  handleOnBlur(event){
    const name = event.target.name;
    this.setState({
      touched: {
        ...this.state.touched, 
        [name]: true
      }
    })
  }

  handleInputChange(event) {
    //general handlerfor updaing the input value into state.
    //grab values from the input
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
      touched: {
        ...this.state.touched, 
        [name]: true
      }
    })
  }

  handleUpdateOrder = async (recordId, data) => {
    if (!recordId || !data) {
      console.log('missing arguments for handleUpdateOrder()');
      return;
    }

    return updateOrder(recordId, data)
      .then(body => {
        if (body?.message === "OK") {
          this.props.onHide();
        } else {
          toast.error(body?.message);
        }
      })
      .catch(body => {
        console.log(body);
      })
  }


  handleSubmit(event) {
    event.preventDefault();

    // Check form for errors
    const errors = validate({
      cancel: this.state.cancel
    });
    const anyError = Object.keys(errors).some(x => errors[x]);
    if (anyError) {
      this.setState({ errors });
      return;
    }

    this.setState({
      submitLabel: 'Cancelling...',
    });

    const body = {
      "fieldData": {
        'Flag_Cancelled_Web' : 1,
        'SMS_Type_Required' : 'Cancel',
        'Cancelled_Timestamp' : format(Date.now(), 'MM/dd/yyyy HH:mm:ss'),
        'Cancelled_Account' : this.props.userFullName,
        '_fk_Customer_UUID' : this.props.order.fieldData._fk_Customer_UUID,
        'z_autoEnterTrigger' : 1,
      } 
    }

    this.handleUpdateOrder( this.props.order['recordId'], body); 
  }

  render() {
    const errors = validate({
      cancel: this.state.cancel
    });

    const order = this.props.order;
    const orderLine = order.portalData.Order_ORDERLINE_web_create[0];
    const orderDate = () => {
      const parts =order.fieldData.Date_Order.split('/');
      const newDate = new Date(parts[2], parts[0] - 1, parts[1]);
      return format(newDate, 'dd/MM/yyyy');
    };
    const fulfilmentTimestamp = () => {
      const method = order.fieldData['Order_CARRIERJOIN_depot_load::Carrier_Organised_By'];
      const timestamp = method === 'SAMI' ? order.fieldData['Order_CARRIERJOIN_depot_load::DeliveryTimeStamp_c'] : order.fieldData['Order_CARRIERJOIN_depot_load::Load_TimeStamp_c'];
      if (!timestamp) { return '';} else {return format(parse(timestamp, 'MM/dd/yyyy HH:mm:ss', new Date() ), 'dd/MM/yyyy hh:mm a');}
    };
    const fulfilmentMethod = () => {
      const method = order.fieldData['Order_CARRIERJOIN_depot_load::Carrier_Organised_By']
      if (!method) { return '';} 
      else if (method === 'SAMI') {return 'Delivery';}
      else if (method === 'Client') {return 'Pick-up';}
    };

    return (
      <>
        <p>You're about to cancel the following order:</p>
        <div className="card-column">
          <div className="order-label">SBT No:</div>
          <div className="order-data">{order.fieldData.SBT_Order_Number}</div>

          <div className="order-label">Your Order No:</div>
          <div className="order-data">{order.fieldData.Order_Number_Customer}</div>   
          
          <div className="order-label">Date:</div>
          <div className="order-data">{orderDate()}</div>                          
          
          <div className="order-label">Product:</div>
          <div className="order-data">{orderLine && orderLine['Order_ORDERLINE_web_create::ItemName_inc_Variant_c'] && orderLine['Order_ORDERLINE_web_create::ItemName_inc_Variant_c']}</div>  

          <div className="order-label">Order Qty:</div>
          <div className="order-data">{orderLine && orderLine['Order_ORDERLINE_web_create::Qty_Ordered'] && 
              (orderLine['Order_ORDERLINE_web_create::Qty_Ordered'] + " " +
                (
                  orderLine["Order_ORDERLINE_web_create::Unit_of_Measure_Short_ordered_ae"] === "Units" &&
                  orderLine["Order_ORDERLINE_web_create::Qty_Ordered"] === 1
                    ? "Unit"
                    : orderLine["Order_ORDERLINE_web_create::Unit_of_Measure_Short_ordered_ae"]
                        ?.replace(/kg/gi, "kg")
                        .replace(/l/g, "L")
                )
              )
            }
          </div>
        </div>
        <div className="card-column">
          <div className="order-label">From Depot:</div>
          <div className="order-data">{order.fieldData['Order_LOCATION::Name']}</div> 
          
          <div className="black order-label">Method:</div>
          <div className="order-data">{fulfilmentMethod()}</div>

          {fulfilmentMethod() === 'Delivery' ? 
            <>
            <div className="order-label">Delivery Point:</div>
            <div className="order-data">{order.fieldData['Order_CARRIERJOIN_depot_load::Delivery_Point']}</div></>
            : ''
          }
            <div className="order-label">Date/Time:</div>
            <div className="order-data">{fulfilmentTimestamp()}</div> 
        </div>

            <hr />


      <Form onSubmit={this.handleSubmit} autoComplete="off">

         {/* Quantity */}
         <Form.Group>
          <Form.Label>Type CANCEL to confirm order cancellation:</Form.Label>
          <InputGroup className="input-half">
            <Form.Control
              name="cancel"
              type="text"
              value={this.state.cancel}
              onChange={this.handleInputChange}
              onBlur={this.handleOnBlur}
              required
            />
          </InputGroup>
          {errors.cancel && this.state.touched.cancel ? <p className="form-error-message">{errors.cancel}</p> : null}

        </Form.Group>


        <Button className="mt-4"variant="primary" type="submit">Cancel Order</Button>
        
      </Form>
      </>
    );
  }
}

export default CancelForm;
